import React, {Fragment, useState, useEffect, useCallback, useRef} from 'react';
import {Icons, Flex, Link, ProgressBar} from 'components';
import {usePages} from 'helpers';
import css from './pager.module.scss';

export function Pager() {
  const { ChevronLeft, ChevronRight } = Icons;
  const { prev, next, total, current } = usePages();
  return (
    <Flex className={css('pager')}>
      <Link to={ prev || '.' }><ChevronLeft className={css.icon} /></Link>
      <span className={css.text}>{ current } / { total }</span>
      <Link to={ next || '.' }><ChevronRight className={css.icon} /></Link>
    </Flex>
  );
}
